<script setup>
import RegionChooser from "./RegionChooser.ce.vue";
import SurveyConfirmation from "../SurveyConfirmation.ce.vue";
import QuestionCategories from "./QuestionCategories.ce.vue";
import QuestionGroup from "./QuestionGroup.ce.vue";
import AlertComponent from "../layouts/AlertComponent.ce.vue"
import { store } from '../../store.js';
import { ref } from "vue";

const props = defineProps({
    survey: {
        type: Object,
        default: () => {
            return {}
        },
    },
});

function showFullSurvey() {
    if (props.survey !== store.survey.full) {
        return false;
    }
    store.fetch.addFullSurvey(store.locale)
    return store.fetch.isReady.fullSurvey;
}

function showMiniSurvey() {
    if (props.survey !== store.survey.mini) {
        return false;
    }
    store.fetch.addMiniSurvey(store.locale)
    return store.fetch.isReady.miniSurvey;
}

const survey = ref(props.survey);

function showSurvey() {
    if (survey.value.isSubmitted === true) {
        return false;
    } else if (showFullSurvey() || showMiniSurvey()) {
        return true
    }

    return false;
}

</script>

<template>
    <template v-if="showSurvey()">
        <RegionChooser v-if="store.numericCountryCode" />
        <div v-if="store.regions.present()" class="mt-4 max-w-screen-md">
            <AlertComponent class="my-4">
                {{ survey.questions.intro }}
            </AlertComponent>
            <template v-if="showFullSurvey()">
                <QuestionCategories :survey="survey" />
            </template>
            <template v-if="showMiniSurvey()">
                <QuestionGroup :question-groups="survey.questions['question_groups']" :survey="survey" />
            </template>
        </div>
    </template>
    <SurveyConfirmation v-if="survey.isSubmitted" :link-to-full-survey="props.survey === store.survey.mini" />
</template>
